module.exports = __webpack_public_path__ + "static/media/City Life - Bordeaux_PR Pink - Bordeaux.f6aae9ea.jpg";